module.exports = __webpack_public_path__ + "static/media/s3-alt.12291ba5.png";